import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { RefAttributes } from 'react';

import type { InferPropTypes, Variant } from '../index.ts';
import styles from './styles.module.scss';
import addVariants from '../utils/addVariants/index.ts';

export const VARIANTS = ['default', 'no-padding', 'comfortable'] as const;

const propTypes = {
  /**
   * The list item text content
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  /**
   * Decides the variant of the list item
   */
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(VARIANTS),
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(VARIANTS), PropTypes.bool]))
  ]),
  /**
   * Additional classnames to apply
   */
  className: PropTypes.string
};
const defaultProps = {
  className: '',
  variant: 'default'
};

export type ListProps = InferPropTypes<
  typeof propTypes,
  typeof defaultProps,
  {
    children: React.ReactNode | React.ReactNode[];
    variant?: Variant<(typeof VARIANTS)[number]>;
  }
> &
  RefAttributes<HTMLUListElement>;
const List = React.forwardRef<HTMLUListElement, ListProps>(
  ({ children, variant: variants, className, ...props }, ref) => (
    <ul
      className={classnames(addVariants('aglmd-list', styles, variants), className)}
      ref={ref}
      {...props}
    >
      {children}
    </ul>
  )
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(List as any).propTypes = propTypes;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(List as any).defaultProps = defaultProps;

export default React.memo(List);
